import { getNumberValuesToCompare, greaterThan, isArrayOfNumbers, isValueEmpty, } from '../utils';
export function valueIsGreaterThan(givenValue, expectedValue, orEqual = false) {
    if (isValueEmpty(givenValue)) {
        return false;
    }
    const values = getNumberValuesToCompare(givenValue, expectedValue);
    if (isArrayOfNumbers(values)) {
        const [given, expected] = values;
        return greaterThan(given, expected, orEqual);
    }
    throw new Error(`GreaterThan operator: Unsupported values to compare ${givenValue}, ${expectedValue}`);
}
//# sourceMappingURL=greater-than.js.map